// extracted by mini-css-extract-plugin
export default {"problem":"ProfileUserInfoValue_problem__hZeY6"};